<template>
  <div>
    <v-row no-gutters v-for="file in computedAttachments" :key="file.id">
      <component
        :is="expanded ? 'TheAttachmentExpanded' : 'TheAttachment'"
        :attachment="file"
        :form-schema="formSchema"
        :layer-id="layerId"
        :feature-id="featureId"
        @deleteFile="$emit('deleteFile', $event)"
      />
    </v-row>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';
import { getIconColorByFileType, getIconByFileType } from '@/assets/js/utility';

import TheAttachment from '@/components/TheAttachment';
import TheAttachmentExpanded from '@/components/TheAttachmentExpanded';

export default {
  components: {
    TheAttachment,
    TheAttachmentExpanded,
  },
  name: 'AttachmentList',
  props: {
    attachments: {
      type: Array,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    formSchema: {
      type: Array,
      default: () => {
        return [];
      },
    },
    layerId: {
      type: [String, Number],
      required: true,
    },
    featureId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    currentUser: get('users/currentUser'),
    token: get('authentication/token'),
    users: get('users/users'),
    documentationLayerId: get('admin/modulesMapping@documentation.documentation_layer_id'),
    currentLayer: get('layers/layers@:layerId'),
    layerImageAttribute() {
      return !!this.currentLayer?.image_attribute;
    },
    computedAttachments() {
      return JSON.parse(JSON.stringify(this.attachments)).map(item => {
        const { added_at, added_by, filename, id, name, is_photo } = item.properties;
        const properties = item.properties;
        delete item.properties;
        return {
          ...item,
          properties,
          id,
          name,
          filename,
          is_photo,
          icon: getIconByFileType(filename),
          iconColor: getIconColorByFileType(filename),
          date: this.$dayjs(added_at).format('L'),
          thumbnailUrl: this.getImageUrl(id, 'thumbnail'),
          fileUrl: this.getImageUrl(id, 'file'),
          subheader: `${this.users[added_by]?.name ? `${this.users[added_by]?.name},` : ''} ${this.$dayjs(
            added_at
          ).format('L')}`,
          dotsItems: this.getDotsItems(this.isOwner(added_by), is_photo),
        };
      });
    },
  },
  methods: {
    getDotsItems(value, isPhoto) {
      return [
        ...(this.expanded && this.documentationLayerId
          ? [
              {
                name: 'openDocument',
              },
            ]
          : []),
        ...(this.layerImageAttribute && isPhoto
          ? [
              {
                name: 'setProfileImage',
              },
            ]
          : []),
        {
          name: 'delete',
          disabled: !value,
        },
        {
          name: 'download',
        },
      ];
    },
    isOwner(id) {
      if (this.currentUser.is_admin || this.currentUser.is_superadmin) {
        return true;
      }
      return id === this.currentUser.id;
    },
    getImageUrl(id, type) {
      return `${process.env.VUE_APP_API_URL}/attachments/${id}/${type}${
        type === 'thumbnail' ? `?token=${this.token}` : ''
      }`;
    },
  },
};
</script>

<style scoped lang="scss"></style>
